import React from 'react';
import { ContentsItem } from '../../../modules/editor/types';

// 에디트 모듈
import { useDispatch, useSelector } from 'react-redux';
import { TEXT_TEMPLATE } from '../../../constants';
import { RootState } from '../../../modules';
import { setMarkedToolbar } from '../../../modules/editor';
import CtaEdit from '../Edit/CtaEdit';
import ImageEdit from '../Edit/ImageEdit';
import TextEdit from '../Edit/TextEdit';

type Props = {
	contentItem: ContentsItem
};

function Base({ contentItem }: Props) {
	const dispatch = useDispatch();

	const markedToolbar = useSelector((state: RootState) => state.editor.markedToolbar);
	const { templateId } = useSelector((state: RootState) => state.editor.email);

	const markToolbar = (contentId: number, currentIndex: number, itemType: string) => {
		dispatch(setMarkedToolbar({
			contentId: contentId,
			currentIndex: currentIndex,
			itemType: itemType
		}))
	}

	const columnPadding = () => {
		return {
			paddingLeft: contentItem.content.style[0].box?.paddingLeft,
			paddingRight: contentItem.content.style[0].box?.paddingRight,
			paddingTop: contentItem.content.style[0].box?.paddingTop,
			paddingBottom: contentItem.content.style[0].box?.paddingBottom,
		}
	}


	const contentRowPadding = (column: string[], row: string, subIndex: number) => {
		const isFirst = subIndex === 0;
		return isFirst ? { padding: '0 0 0 0' } : { padding: '20px 0 0 0' };
	}

	return (
		<>
			{
				contentItem.content.column.map((column: string[], index: number) => (
					<div
						key={index}
						className={`content-column column-index-${index}`}
						style={templateId === TEXT_TEMPLATE ? {} : columnPadding()}
					>
						{
							column.map((row: string, subIndex: number) => (
								<div
									key={subIndex}
									className="content-row"
									style={contentRowPadding(column, row, subIndex)}
								>
									{row === 'text' && (
										<TextEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].text}
											boxStyle={contentItem.content.style[index].box}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
											textTemplate={templateId === TEXT_TEMPLATE}
										/>
									)}
									{row === 'cta' && (
										<CtaEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].button}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
									{row === 'image' && (
										<ImageEdit
											contentId={contentItem.id}
											contentIndex={index}
											innerContent={contentItem.content.content[index]}
											style={contentItem.content.style[index].image}
											columnCount={contentItem.content.column.length}
											editing={contentItem.content.editing}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
								</div>
							))
						}
					</div>
				))
			}
		</>
	)
}

export default Base;